import { render, staticRenderFns } from "./InsuranceRisks.vue?vue&type=template&id=46f31563&scoped=true&"
import script from "./InsuranceRisks.vue?vue&type=script&lang=js&"
export * from "./InsuranceRisks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f31563",
  null
  
)

export default component.exports